import React from "react";

import MembershipForm from "../components/MembershipForm/MembershipForm";

const MembershipFormPage = () => (
    <MembershipForm />
)

export default MembershipFormPage;